import React from "react";
import { Image } from "react-bootstrap";
import "../offline/offline.css";
import Logo from "../../images/logo.png";

const ErrorPage = () => {
  return (
    <div className="offline">
      <div>
        <Image className="mb-5" src={Logo} alt="Vikaaria logo" />
        <div>Something unexpected happened, please try again.</div>
        <button onClick={() => window.location.reload(true)}>Reload</button>
      </div>
    </div>
  );
};

export default ErrorPage;
